import { STATES } from '../../../../../constants';
import { isFeatureEnabled } from '@updater-core/lib/optimizely';

export function ForwardMailNewConfig($stateProvider) {
  'ngInject';
  $stateProvider.state(STATES.STEP_FORWARD_MAIL_NEW, {
    url: '/file-form',
    views: {
      '@': {
        template: async () => {
          const isInRedesignTest = await isFeatureEnabled('fym_reskin');
          return isInRedesignTest
            ? '<uds-forward-mail-new class="uds"></uds-forward-mail-new>'
            : '<upd-forward-mail-new></upd-forward-mail-new>';
        },
      },
    },
    scrollTop: true,
    title: 'File A New Form',
    analytics: {
      page: 'File Forward Mail',
    },
    data: {
      permissions: 'signedIn && !military',
      militaryState: STATES.STEP_FORWARD_MAIL_MILITARY,
    },
    titleBar: {
      title: 'Forward Your Mail',
      save: 'Average Time Saved: 20 minutes',
    },
  });
}
